'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAgentResponder = undefined;

var _createAsyncAction = require('conversations-async-data/async-action/createAsyncAction');

var _buildRequestErrorMetaObject = require('conversations-error-reporting/error-actions/builders/buildRequestErrorMetaObject');

var _Responder = require('conversations-schema/responders/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _fetchAgentResponder = require('../clients/fetchAgentResponder');

var _asyncActionTypes = require('../constants/asyncActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchAgentResponder = exports.fetchAgentResponder = (0, _createAsyncAction.createAsyncAction)({
  actionTypes: _asyncActionTypes.FETCH_AGENT_RESPONDER,
  requestFn: _fetchAgentResponder.fetchAgentResponder,
  toRecordFn: _Responder2.default,
  failureMetaActionCreator: _buildRequestErrorMetaObject.buildRequestErrorMetaObject
});